import { Button, ButtonIcon, css, styled } from 'canoe';

export const ContentFolderWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spaces.s};
    padding: ${theme.spaces.normal};
    border: 1px solid ${theme.colors.GlitterGrayL10};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const CreateFolderContent = styled(Button)`
  // prettier-ignore

  ${ContentFolderWrapper}:not(:hover) & {
    display: none;
  }
`;

export const DeleteFolderIcon = styled(ButtonIcon)`
  // prettier-ignore

  ${ContentFolderWrapper}:not(:hover) & {
    display: none;
  }
`;

export const AddSectionWrapper = styled.div`
  ${({ theme }) => css`
    height: ${theme.spaces.l};
    display: flex;
    align-items: center;
    gap: ${theme.spaces.s};
  `}
`;

export const AddSectionSeparator = styled.div`
  ${({ theme }) => css`
    height: 1px;
    background: ${theme.colors.GlitterGrayL10};
    flex-grow: 1;
  `}
`;

export const AddSectionButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spaces.xs};
    cursor: pointer;
  `}
`;

export const NoResultsWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border: 1px solid ${theme.colors.GlitterGrayL10};
    border-radius: ${theme.borderRadius.small};
    display: flex;
    justify-content: center;
    padding: ${theme.spaces.normal};
  `}
`;
